import { render, staticRenderFns } from "./LoginBox.vue?vue&type=template&id=3b48ae7a&"
import script from "./LoginBox.vue?vue&type=script&lang=js&"
export * from "./LoginBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports